/**
 * Created by r4zi4l on 22.06.2022
 */

// GameBase.REWARD_HARD
Reward.register(["hard", "rubies"], {
    currency: true,
    controls: "MenuBarGoldItem",
    flyingAnimation: Reward.JUMP_COLLECT_ANIMATION,
    target: "hard",

    getIcon: function () {
        return bundles.reward_icons.frames.reward_gold_png;
    },

    getSmallIcon: function () {
        return bundles.reward_icons.frames.gold_small_png;
    },

    getPrice: function (value) {
        return value;
    },

    receive: function (value, options) {
        if (!cleverapps.isNumber(value)) {
            cleverapps.throwAsync(`RewardTypes.hard - ${value}`);
            value = 0;
        }
        cleverapps.user.earnHard(options.event, value, true);
        return cleverapps.pendingRewards.add("hard", value, () => {
            cleverapps.user.onChangeHard();
        });
    }
});

Reward.register("soft", {
    currency: true,
    controls: "MenuBarCoinsItem",
    flyingAnimation: Reward.JUMP_COLLECT_ANIMATION,
    target: "soft",

    getIcon: function () {
        return bundles.reward_icons.frames.reward_coin_png;
    },

    getSmallIcon: function () {
        return bundles.reward_icons.frames.coin_small_png;
    },

    getPrice: function (value) {
        return value / cleverapps.User.HARD_TO_SOFT;
    },

    receive: function (value, options) {
        if (!cleverapps.isNumber(value)) {
            cleverapps.throwAsync(`RewardTypes.soft - ${value}`);
            value = 0;
        }
        cleverapps.user.setSoft(cleverapps.user.soft + value, true, options);
        return cleverapps.pendingRewards.add("soft", value, () => {
            cleverapps.user.trigger("changeSoft");
        });
    }
});

// GameBase.REWARD_EXP
Reward.register("exp", {
    currency: true,
    controls: "MenuBarAvatarItem",
    get flyingAnimation() {
        if (["merge", "merge2", "farm"].includes(cleverapps.config.type)) {
            return Reward.JUMP_COLLECT_ANIMATION;
        }
        if (typeof AdventureExpedition !== "undefined"
            && AdventureExpedition.LOCATION_IDS.includes(cleverapps.meta.selectedLocationId())) {
            return Reward.JUMP_COLLECT_ANIMATION;
        }
        return false;
    },

    getIcon: function () {
        return cleverapps.skins.getSlot("reward_exp_png") || bundles.reward_icons.frames.reward_exp_png;
    },

    getSmallIcon: function () {
        return cleverapps.skins.getSlot("reward_exp_small_png") || bundles.reward_icons.frames.reward_exp_small_png;
    },

    parse: function (value, options) {
        if (!cleverapps.exp.isAvailable()) {
            return [];
        }
        return [new Reward("exp", value, options)];
    },

    receive: function (value) {
        if (!cleverapps.isNumber(value)) {
            cleverapps.throwAsync(`RewardTypes.exp - ${value}`);
            value = 0;
        }
        cleverapps.exp.setExp(cleverapps.exp.getExp() + value, true);
        return cleverapps.pendingRewards.add("exp", value, () => {
            cleverapps.exp.onChange();
        });
    }
});

// GameBase.REWARD_BOOSTERS
// value: { id, amount }; config: { [boosterId | boosterType]: amount }, resolved by cleverapps.boosters.resolveRewardBoosters
Reward.register("boosters", {
    countable: true,
    icon: {},
    smallIcon: {},

    getIcon: function (value) {
        return this.icon[value.id];
    },

    getSmallIcon: function (value) {
        return this.smallIcon[value.id];
    },

    getTarget: function (value, options) {
        if (options.fromRewardWindow && cleverapps.aims.getTarget("play_button", { noDefault: true })) {
            return "play_button";
        }
        return `boosters${value.id}`;
    },

    getPrice: function (value) {
        return cleverapps.Boosters.getPrice(value.id) * value.amount;
    },

    matches: function (value, key) {
        return value.id === key || cleverapps.Boosters.CONFIG[value.id].type === key;
    },

    parse: function (value, options) {
        const byBoosterId = cleverapps.boosters.resolveRewardBoosters(value);
        return Object.keys(byBoosterId).map((id) => new Reward("boosters", { id, amount: byBoosterId[id] }, options));
    },

    receive: function (value) {
        const available = value.amount > 0;
        const booster = cleverapps.boosters.getBoosterById(value.id);
        if (available) {
            booster.inRewardAnimation = true;
            cleverapps.boosters.add(value.id, value.amount, true);
        }
        return function () {
            if (available) {
                booster.inRewardAnimation = false;
                booster.onChange();
            }
        };
    }
});

RewardTypes.boosters.icon[cleverapps.Boosters.TYPE_CELL] = bundles.reward_icons.frames.cellbooster;
RewardTypes.boosters.icon[cleverapps.Boosters.TYPE_LINE] = bundles.reward_icons.frames.linebooster;
RewardTypes.boosters.icon[cleverapps.Boosters.TYPE_COLOR] = bundles.reward_icons.frames.colorbooster;
RewardTypes.boosters.icon[cleverapps.Boosters.TYPE_HINT] = bundles.reward_icons.frames.hint_icon_png;
RewardTypes.boosters.icon[cleverapps.Boosters.TYPE_OPEN_LETTER] = bundles.reward_icons.frames.open_letter_icon_png;
RewardTypes.boosters.icon[cleverapps.Boosters.TYPE_WILDCARD] = bundles.reward_icons.frames.wildcard_png;
RewardTypes.boosters.icon[cleverapps.Boosters.TYPE_BRUSH] = bundles.reward_icons.frames.pot;
RewardTypes.boosters.icon[cleverapps.Boosters.TYPE_DISCOVER] = bundles.reward_icons.frames.hat;
RewardTypes.boosters.icon[cleverapps.Boosters.TYPE_COMBO] = bundles.reward_icons.frames.heroes_png;
RewardTypes.boosters.icon[cleverapps.Boosters.TYPE_MOVES] = bundles.reward_icons.frames.moves_png;
RewardTypes.boosters.icon[cleverapps.Boosters.TYPE_MULTICOLOR] = bundles.reward_icons.frames.multicolor_png;
RewardTypes.boosters.icon[cleverapps.Boosters.TYPE_MAGNET] = bundles.reward_icons.frames.magnet_png;
RewardTypes.boosters.icon[cleverapps.Boosters.TYPE_DICE] = bundles.reward_icons.frames.dice_png;
RewardTypes.boosters.icon[cleverapps.Boosters.TYPE_JOKERS] = bundles.reward_icons.frames.joker_png;
RewardTypes.boosters.icon[cleverapps.Boosters.TYPE_HIGHLIGHT] = bundles.reward_icons.frames.highlight;
RewardTypes.boosters.icon[cleverapps.Boosters.TYPE_EYE] = bundles.reward_icons.frames.eye;
RewardTypes.boosters.icon[cleverapps.Boosters.TYPE_SHUFFLE] = bundles.reward_icons.frames.shuffle;
RewardTypes.boosters.icon[cleverapps.Boosters.TYPE_MAGNIFIER] = bundles.reward_icons.frames.hint;
RewardTypes.boosters.icon[cleverapps.Boosters.TYPE_UNDO] = bundles.reward_icons.frames.booster_undo_png;
RewardTypes.boosters.icon[cleverapps.Boosters.TYPE_TILE_SHUFFLE] = bundles.reward_icons.frames.booster_tile_shuffle_png;
RewardTypes.boosters.icon[cleverapps.Boosters.TYPE_VACUUM] = bundles.reward_icons.frames.booster_vacuum_png;
RewardTypes.boosters.icon[cleverapps.Boosters.TYPE_REPLACE_ALL] = bundles.reward_icons.frames.booster_replace_all_png;
RewardTypes.boosters.icon[cleverapps.Boosters.TYPE_CLEAR_PIECES] = bundles.reward_icons.frames.booster_clear_pieces_png;
RewardTypes.boosters.icon[cleverapps.Boosters.TYPE_UNDO_PIECE] = bundles.reward_icons.frames.booster_undo_piece_png;
RewardTypes.boosters.icon[cleverapps.Boosters.TYPE_BOMB] = bundles.reward_icons.frames.booster_bomb_png;
RewardTypes.boosters.smallIcon[cleverapps.Boosters.TYPE_CELL] = bundles.reward_icons.frames.cellbooster_small;
RewardTypes.boosters.smallIcon[cleverapps.Boosters.TYPE_LINE] = bundles.reward_icons.frames.linebooster_small;
RewardTypes.boosters.smallIcon[cleverapps.Boosters.TYPE_COLOR] = bundles.reward_icons.frames.colorbooster_small;
RewardTypes.boosters.smallIcon[cleverapps.Boosters.TYPE_HINT] = bundles.reward_icons.frames.hint_icon_png;
RewardTypes.boosters.smallIcon[cleverapps.Boosters.TYPE_WILDCARD] = bundles.reward_icons.frames.wildcard_small_png;
RewardTypes.boosters.smallIcon[cleverapps.Boosters.TYPE_BRUSH] = bundles.reward_icons.frames.pot_small;
RewardTypes.boosters.smallIcon[cleverapps.Boosters.TYPE_DISCOVER] = bundles.reward_icons.frames.hat_small;
RewardTypes.boosters.smallIcon[cleverapps.Boosters.TYPE_COMBO] = bundles.reward_icons.frames.heroes_small_png;
RewardTypes.boosters.smallIcon[cleverapps.Boosters.TYPE_MOVES] = bundles.reward_icons.frames.moves_small_png;
RewardTypes.boosters.smallIcon[cleverapps.Boosters.TYPE_MULTICOLOR] = bundles.reward_icons.frames.multicolor_small_png;
RewardTypes.boosters.smallIcon[cleverapps.Boosters.TYPE_MAGNET] = bundles.reward_icons.frames.magnet_small_png;
RewardTypes.boosters.smallIcon[cleverapps.Boosters.TYPE_DICE] = bundles.reward_icons.frames.dice_small_png;
RewardTypes.boosters.smallIcon[cleverapps.Boosters.TYPE_JOKERS] = bundles.reward_icons.frames.joker_small_png;
RewardTypes.boosters.smallIcon[cleverapps.Boosters.TYPE_HIGHLIGHT] = bundles.reward_icons.frames.highlight_small;
RewardTypes.boosters.smallIcon[cleverapps.Boosters.TYPE_EYE] = bundles.reward_icons.frames.eye_small;
RewardTypes.boosters.smallIcon[cleverapps.Boosters.TYPE_MAGNIFIER] = bundles.reward_icons.frames.hint_small;
RewardTypes.boosters.smallIcon[cleverapps.Boosters.TYPE_SHUFFLE] = bundles.reward_icons.frames.shuffle_small;

Reward.register("randomBoosters", {
    countable: true,
    getIcon: function () {
        return bundles.reward_icons.frames.boosters_common_small_png;
    },

    getSmallIcon: function () {
        return bundles.reward_icons.frames.boosters_common_small_png;
    },

    receive: function () {
        return function () {};
    }
});

Reward.register("moves", {
    countable: true,
    getIcon: function () {
        return bundles.reward_icons.frames.moves_png;
    },

    getSmallIcon: function () {
        return bundles.reward_icons.frames.moves_small_png;
    },

    receive: function () {
        return function () {};
    }
});

// value: { missionType, amount }
Reward.register("mission", {
    icon: {},
    smallIcon: {},

    flyingAnimation: ["merge", "merge2"].includes(cleverapps.config.type) && Reward.JUMP_COLLECT_ANIMATION,

    getIcon: function (value) {
        const missionType = Mission.GetMissionType(value.missionType);
        return this.icon[missionType] || Mission.getCollectIcon(missionType);
    },

    getSmallIcon: function (value) {
        const missionType = Mission.GetMissionType(value.missionType);
        return this.smallIcon[missionType];
    },

    getTarget: function (value, options) {
        return !options.withoutSidebar && `mission${value.missionType}`;
    },

    getFlyingAmount: function (amount, value) {
        if (value.missionType === Mission.TYPE_KRAKENFEAST) {
            return Math.min(3, amount);
        }
        if (value.missionType === Mission.TYPE_SOFTFEAST) {
            if (amount >= 500) {
                return 4;
            }
            if (amount >= 150) {
                return 3;
            }
            if (amount) {
                return 2;
            }
        }
        if ([Mission.TYPE_LIVESFEAST, Mission.TYPE_KINGSCUP].includes(value.missionType)) {
            if (amount >= 20) {
                return 3;
            }
            if (amount >= 10) {
                return 2;
            }
            if (amount) {
                return 1;
            }
        }
        return RewardType.prototype.getFlyingAmount.call(this, amount, value);
    },

    getFlyEffect: function (value) {
        return value.missionType === Mission.TYPE_SOFTFEAST ? "meta.coins.collect" : undefined;
    },

    parse: function (value, options) {
        if (!Array.isArray(value)) {
            value = [value];
        }

        return value.filter((rw) => cleverapps.missionManager.findRunningMission(rw.missionType))
            .map((rw) => new Reward("mission", rw, options));
    },

    receive: function (value) {
        let mission = cleverapps.missionManager.findByType(value.missionType);
        if (mission && !mission.isRunning()) {
            mission = undefined;
        }
        if (mission) {
            if (mission.isPassMission() || mission.isTreasureSearchMission()) {
                cleverapps.missionManager.dispatchEvent(mission, value);
            } else if (mission.isSlotMachineMission()) {
                mission.logic.slotMachine.setTickets(mission.logic.slotMachine.tickets + value.amount, true);
            } else if (mission.isPinballMission()) {
                mission.logic.updateChips(value.amount);
            } else {
                mission.update(value.amount, undefined, true);
            }
            mission.logEvent(Mission.EVENTS.MISSION_POINTS, { value: value.amount });
        }

        return cleverapps.once(() => {
            if (mission) {
                mission.onUpdateMission(value.amount);

                if (mission.isSlotMachineMission()) {
                    mission.logic.slotMachine.trigger("updateTickets");
                }
            }
        });
    }
});

Reward.register("kraken", {
    countable: true,
    flyingAnimation: Reward.NO_ANIMATION,

    getIcon: function () {
        return bundles.reward_icons.frames.tentacle_png;
    },

    getAmount: function (value) {
        return value.amount || 1;
    },

    getText: function (value, prefix) {
        return `${this.getPrefix(prefix)}3`;
    },

    receive: function () {
        Map2dLocation.currentLocation.monstersPlanner.spawnToAllSlots();
        return function () {};
    }
});

Reward.register("pinballTickets", {
    countable: true,
    getIcon: function () {
        return bundles.reward_icons.frames.pinball_ticket_png;
    },

    flyingAnimation: Reward.JUMP_COLLECT_ANIMATION,

    receive: function (value) {
        const mission = cleverapps.missionManager.findByType(Mission.TYPE_PINBALL);
        mission.logic.updateTickets(value.amount || 0);

        return function () {};
    }
});

Reward.register("pinballChips", {
    getIcon: function () {
        return bundles.reward_icons.frames.pinball_token_png;
    },

    flyingAnimation: Reward.JUMP_COLLECT_ANIMATION,

    receive: function (value) {
        const mission = cleverapps.missionManager.findByType(Mission.TYPE_PINBALL);
        mission.logic.updateChips(value || 0);

        return function () {};
    }
});

Reward.register("metaStar", {
    getIcon: function () {
        return bundles.reward_icons.frames.simple_star_png;
    },

    receive: function (value) {
        const location = cleverapps.meta.getSelectedLocation();
        location.changeStars(value, true);

        return function () {
            location.onChangeStars(value);
        };
    }
});

Reward.register("locationProgress", {
    getIcon: function () {
        return bundles.reward_icons.frames.simple_star_png;
    },

    receive: function (value) {
        const location = cleverapps.meta.getSelectedLocation();
        location.changeProgress(value, true);

        return cleverapps.pendingRewards.add("locationProgress", value, () => {
            location.onUpdateProgress();
        });
    }
});

Reward.register("orderStar", {
    flyingAnimation: Reward.JUMP_COLLECT_ANIMATION,

    getIcon: function () {
        return bundles.reward_icons.frames.order_completion_star_png;
    },

    getSmallIcon: function () {
        return bundles.reward_icons.frames.order_completion_star_png;
    },

    receive: function (value) {
        const locationStars = cleverapps.meta.getSelectedLocation().stars;
        locationStars.addStars(value, true);
        cleverapps.eventBus.trigger("earn_stars", value);

        return function () {
            locationStars.onChangeStars();
        };
    }
});

Reward.register("extraCells", {
    countable: true,
    getIcon: function () {
        return undefined; 
    },

    receive: function () {
        return function () {};
    }
});
